export default __webpack_public_path__ + "static/media/logo.2afa6ff8.jpg";